<template>
  <tr>
    <td>
      <router-link
        :to="{
          name: 'single-order',
          params: { id: props.item.number },
        }"
        class="text-no-wrap"
      >
        {{ props.item.number }}
      </router-link>
    </td>
    <td>
      <router-link
        v-if="props.item.customer.customer_id"
        :to="{
          name: 'single_customer',
          params: { id: props.item.customer.customer_id },
        }"
        :color="props.item.status | orderStatusColor"
      >
        {{ props.item.customer.firstname }}
        {{ props.item.customer.lastname }}
      </router-link>
      <template v-else>
        {{ props.item.customer.firstname }}
        {{ props.item.customer.lastname }}
      </template>
    </td>
    <td>
      <v-chip
        :color="props.item.status | orderStatusColor"
        label
        small
        text-color="white"
      >
        {{ status }}
      </v-chip>
      <v-chip
        v-if="!props.item.customer.customer_id"
        :color="'guest' | orderStatusColor"
        label
        small
        text-color="white"
      >
        {{ $t("guest") }}
      </v-chip>
    </td>
    <td>{{ props.item.updated_at | timezone }}</td>
    <td>{{ props.item.summary.total_items_count }}</td>
    <td class="text-no-wrap">{{ props.item.summary.total_due | money }}</td>
    <td>{{ props.item.created_by ? props.item.created_by.name : "" }}</td>
    <td>{{ props.item.created_by ? props.item.created_by.from : "" }}</td>
    <td v-if="withRequestedDelivery">
      {{ props.item.requested_delivery | formatRequestedDelivery }}
    </td>
    <td>{{ props.item.created_at | timezone }}</td>
  </tr>
</template>
<script>
export default {
  name: 'OrderDataTableRow',

  props: {
    props: {
      type: Object,
      required: true
    },
    withRequestedDelivery: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    status () {
      return (
        this.$t(this.props.item.status).charAt(0).toUpperCase() +
        this.$t(this.props.item.status).slice(1).replace('_', ' ')
      )
    }
  }
}
</script>
